import { forceReload } from "../../../utils/nativeUtils/customActions";

export const reportError = (error: Error, info: unknown) => {
  // add API/new relic call to log error
  console.error("reportError", error.name, error.message, error.stack, info);
};

export const resetAfterError = () => {
  forceReload();
};
